export default __webpack_public_path__ + "static/media/terrainIcon.60fc6efd.png";